import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { LogoNohra } from '@/shared/components/LogoNohra';
import { ROTAS } from '@/shared/lib/rotas';
import { Card, CardContent, CardDescription, CardHeader } from '@/shared/ui/card';

/**
 * Moldura das telas públicas de auth, portada da V1: gradiente de marca em tela
 * cheia, três glows com blur e um card centralizado de `max-w-md`.
 *
 * As cores aqui são hex literais de propósito — na V1 esta tela sobrevive aos
 * dois temas justamente por não depender das CSS variables.
 */
export function AuthShell({
  descricao,
  children,
  larguraMaxima = 'max-w-md',
}: {
  descricao: string;
  children: ReactNode;
  larguraMaxima?: string;
}) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#691241] via-[#975ea1] to-[#15acb7] p-4 py-8 relative overflow-hidden">
      <div className="absolute top-20 left-20 w-72 h-72 bg-[#a2195b]/30 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#15acb7]/20 rounded-full blur-3xl" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#975ea1]/10 rounded-full blur-3xl" />

      <Card
        className={`w-full ${larguraMaxima} bg-surface-raised/95 backdrop-blur-sm border-brand/30 shadow-2xl`}
      >
        <CardHeader className="space-y-1 pb-4">
          {/* Logo clicável: com a landing em `/`, quem chega no login sem conta
              precisa de um caminho de volta para ler o que o produto faz. */}
          <div className="flex justify-center mb-2">
            <Link to={ROTAS.home} aria-label="Voltar para a página inicial">
              <LogoNohra tamanho="lg" />
            </Link>
          </div>
          <CardDescription className="text-center text-muted-foreground font-medium">
            {descricao}
          </CardDescription>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  );
}
